import { createUseStyles } from 'react-jss';
import type { ReactNode } from 'react';

import type { LcpnTheme } from '../../styles/theme';

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  shareLink: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(4),
    backgroundColor: theme.colors['grey-100'],
    padding: theme.spacing(4),
    cursor: 'pointer',
    color: theme.colors.darker,
  },

  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
  },

  [`@media screen and (max-width: ${theme.breakPoints.tablet}px)`]: {
    buttonGroup: {
      paddingBottom: theme.spacing(6),
    },
  },

  button: {
    display: 'flex',
    alignItems: 'center',
    outline: 'none',
    border: 'none',
    backgroundColor: theme.colors.white,
    borderRadius: 20,
    padding: theme.spacing(0, 8),
    minHeight: theme.spacing(9),
  },
}));

type Props = {
  children: ReactNode;
};

export function ShareLink(props: Props) {
  const classes = useStyles();
  const { children } = props;
  return <div className={classes.shareLink}>{children}</div>;
}
